module.exports = __webpack_public_path__ + "static/img/xingtu-loading-bg.916ae77.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/xingtu-loading-bg.png
// module id = dtKg
// module chunks = 0